/** 首页西班牙语 */
export default {
    heroTitlePart1: 'GBWhatsApp APK',
    heroTitleHighlight: 'Descargar',
    heroTitlePart2: 'Última Versión 2026',
    heroDesc:
      'Descarga GBWhatsApp APK con protección anti-baneo. Obtén la última versión con funciones exclusivas, mayor privacidad y opciones de personalización ilimitadas.',
    heroBtn: 'Descargar GBWhatsApp APK (85MB)',
    versionInfo: 'Última versión: v18.80 | Actualizado: Marzo 2026',
    tocTitle: 'Tabla de contenidos',
    tocWhatIs: 'Qué es GBWhatsApp',
    tocFeatures: 'Características principales',
    tocDownload: 'Descargar GBWhatsApp',
    tocInstall: 'Guía de instalación',
    tocVsWa: 'GBWhatsApp vs WhatsApp',
    tocVsMods: 'GBWhatsApp vs otros MODs',
    tocPrivacy: 'Privacidad',
    tocCustom: 'Opciones de personalización',
    tocAntiBan: 'Protección anti-baneo',
    tocFaq: 'Preguntas frecuentes',
    tocAlternatives: 'Alternativas a GBWhatsApp',
    tocSafety: '¿Es seguro GBWhatsApp?',
    tocUpdate: 'Novedades de la última versión',
    tocTrouble: 'Solución de problemas',
    tocConclusion: 'Conclusión',
    whatIsTitle: '¿Qué es GBWhatsApp?',
    whatIsP1:
      'GBWhatsApp es una versión modificada del WhatsApp oficial que ofrece funciones mejoradas y opciones de personalización que no están disponibles en la aplicación original. Desarrollado por desarrolladores independientes, GBWhatsApp ofrece controles de privacidad avanzados, capacidades ampliadas para compartir medios y muchas opciones de personalización que transforman la experiencia de mensajería.',
    whatIsP2:
      'A diferencia de la aplicación oficial de WhatsApp, GBWhatsApp permite personalizar casi todos los aspectos de la interfaz, desde los colores del tema hasta los estilos de fuente, y ofrece funciones como ocultar el estado en línea, los ticks azules y los indicadores de escritura. Esto lo convierte en una opción ideal para quienes desean más control sobre su privacidad y apariencia en la mensajería.',
    whatIsP3:
      'La aplicación se actualiza periódicamente para garantizar la compatibilidad con las últimas versiones de Android y añadir nuevas funciones. GBWhatsApp v18.80, la última versión, incluye mejor protección anti-baneo y nuevas funciones que hacen la mensajería más agradable que nunca.',
    keyFeaturesTitle: 'Características principales de GBWhatsApp',
    keyFeaturesIntro:
      'GBWhatsApp ofrece un conjunto completo de funciones que lo distinguen de la aplicación oficial de WhatsApp. Estas son las más destacadas:',
    downloadTitle: 'Descargar GBWhatsApp APK',
    downloadIntro:
      'Descarga la última versión de GBWhatsApp APK gratis. Nuestras descargas están verificadas y son seguras.',
    downloadBtn: 'Descargar GBWhatsApp APK v18.80',
    downloadInfo: 'Tamaño: 85MB | Android 5.0+ requerido',
    installTitle: 'Cómo instalar GBWhatsApp',
    installIntro:
      'Sigue estos pasos para instalar GBWhatsApp en tu dispositivo Android:',
    installNoteHtml:
      '<strong>Nota:</strong> Si desinstalas el WhatsApp oficial antes de instalar GBWhatsApp, puedes perder el historial de chats. ¡Haz una copia de seguridad antes!',
    cmpFeature: 'Función',
    cmpGb: 'GBWhatsApp',
    cmpOfficial: 'WhatsApp oficial',
    cmpYes: 'Sí',
    cmpNo: 'No',
    cmpLimited: 'Limitado',
    cmpThousands: 'Miles',
    cmpBuiltIn: 'Integrado',
    vsWaTitle: 'GBWhatsApp vs WhatsApp oficial',
    vsWaIntroHtml:
      'Aunque ambas apps permiten enviar mensajes y llamar, <a href="/" class="jump-url">GBWhatsApp</a> ofrece ventajas importantes frente al WhatsApp oficial:',
    vsModsTitle: 'GBWhatsApp vs otros MODs de WhatsApp',
    vsModsIntroHtml:
      'Existen varias modificaciones de WhatsApp, pero <strong><a href="/" class="jump-url">GB WhatsApp</a></strong> sigue siendo una de las más populares. Así se compara con otros mods conocidos:',
    vsModsFmTitle: 'GBWhatsApp vs FMWhatsApp',
    vsModsFmP:
      'Tanto GB WhatsApp como FMWhatsApp ofrecen personalización parecida, pero <strong>GB WhatsApp</strong> destaca por actualizaciones más frecuentes y mejor protección anti-baneo. FMWhatsApp tiene una colección de temas singular, mientras que GBWhatsApp ofrece más opciones de privacidad.',
    vsModsYoTitle: 'GBWhatsApp vs YoWhatsApp',
    vsModsYoP:
      'YoWhatsApp es conocido por su gran biblioteca de temas y personalización fina. <strong>GB WhatsApp</strong> pone más énfasis en la privacidad y en actualizaciones de seguridad. Ambos incluyen buenas funciones anti-baneo.',
    vsModsPlusTitle: 'GBWhatsApp vs WhatsApp Plus',
    vsModsPlusP:
      'WhatsApp Plus fue de los primeros mods. <strong>GB WhatsApp</strong> suele actualizarse más y es más compatible con Android reciente. También cuenta con una comunidad de usuarios grande para soporte.',
    linkDlFm: 'Descargar FMWhatsApp',
    linkDlYo: 'Descargar YoWhatsApp',
    linkDlPlus: 'Descargar WhatsApp Plus',
    privacyTitle: 'Funciones de privacidad de GBWhatsApp',
    privacyIntro:
      'La privacidad es una de las principales razones para elegir GB WhatsApp. La app ofrece controles amplios:',
    customTitle: 'Opciones de personalización de GBWhatsApp',
    customIntro:
      'GBWhatsApp permite personalizar casi todo para que tu experiencia de mensajería sea única:',
    customThemesH3: 'Temas',
    customThemesP:
      'Elige entre miles de temas listos para usar o crea el tuyo. Los temas cambian colores, fuentes y el aspecto general. La tienda en línea se actualiza con frecuencia.',
    customFontsH3: 'Fuentes',
    customFontsP:
      'Cambia el estilo de fuente en toda la app. GBWhatsApp incluye varias fuentes y admite fuentes propias desde el dispositivo.',
    customConvH3: 'Temas por conversación',
    customConvP:
      'Aplica temas distintos a cada chat, con colores y fondos personalizados.',
    customHeaderH3: 'Estilos de cabecera',
    customHeaderP:
      'Personaliza la cabecera del chat con distintos estilos y colores.',
    customNotifH3: 'Estilos de notificaciones',
    customNotifP:
      'Ajusta iconos de notificación y la apariencia del panel.',
    antiBanTitle: 'Protección anti-baneo',
    antiBanIntro:
      'GBWhatsApp incluye protección anti-baneo integrada para ayudar a proteger tu cuenta. Ningún mod garantiza el 100% de seguridad, pero estas funciones reducen bastante el riesgo de suspensión:',
    antiBanTipHtml:
      '<strong>Consejo:</strong> Para reducir riesgos, evita el spam masivo o herramientas automáticas. Usa GBWhatsApp de forma similar al WhatsApp oficial.',
    faqTitle: 'Preguntas frecuentes',
    altTitle: 'Alternativas a GBWhatsApp',
    altIntro:
      'Si buscas otros mods de WhatsApp, aquí tienes opciones populares:',
    safetyTitle: '¿Es seguro descargar GBWhatsApp?',
    safetyIntro:
      'GBWhatsApp lo desarrollan terceros y no está afiliado a WhatsApp Inc., pero suele considerarse seguro si se descarga de fuentes fiables. Consejos de seguridad:',
    safetyDisclaimer:
      'Aviso: GBWhatsApp es una versión modificada no respaldada oficialmente por WhatsApp Inc. Úsalo bajo tu responsabilidad.',
    updateTitle: 'Novedades de la última versión de GBWhatsApp',
    updateIntro:
      'La versión más reciente (v18.80) incluye las siguientes mejoras:',
    troubleTitle: 'Solución de problemas de GBWhatsApp',
    troubleIntro:
      'Respuestas a problemas habituales con GBWhatsApp:',
    conclusionTitle: 'Conclusión',
    conclusionP1:
      'GBWhatsApp es una excelente opción si quieres más control sobre tu experiencia: personalización amplia, privacidad avanzada y actualizaciones frecuentes frente al WhatsApp oficial.',
    conclusionP2:
      'Los mods siempre llevan algo de riesgo, pero la protección anti-baneo de GBWhatsApp y un uso prudente lo reducen mucho. La app se actualiza de forma continua para compatibilidad y seguridad.',
    conclusionP3:
      'Descarga GBWhatsApp hoy y prueba mensajería con más funciones y más control sobre tu privacidad.',
    keyFeatureItems: [
      { title: 'Controles de privacidad:', body: 'Oculta estado en línea, ticks azules, segundo tick, «escribiendo…» y grabación. Opciones distintas por contacto.' },
      { title: 'Temas personalizados:', body: 'Miles de temas o crea el tuyo. La tienda de temas se renueva con nuevos diseños.' },
      { title: 'Compartir medios ampliado:', body: 'Vídeos hasta 90MB, imágenes sin compresión y documentos hasta 100MB.' },
      { title: 'Respuesta automática:', body: 'Mensajes automáticos cuando no puedas responder, personalizables por contacto.' },
      { title: 'Programar mensajes:', body: 'Envía mensajes a una hora concreta. Ideal para felicitaciones o recordatorios.' },
      { title: 'Modo no molestar:', body: 'Corta solo Internet de GBWhatsApp mientras sigues usando otras apps.' },
      { title: 'Mensajes anti-borrado:', body: 'Ve mensajes que otros borraron o que el remitente eliminó.' },
      { title: 'Fuentes personalizadas:', body: 'Cambia la tipografía en toda la app o usa tus propias fuentes.' },
      { title: 'Descarga de estados:', body: 'Guarda vídeos e imágenes de estados antes de que caduquen.' },
      { title: 'Varias cuentas:', body: 'Varias cuentas de GBWhatsApp en un solo dispositivo con la función de app paralela.' },
      { title: 'Bloqueo de la app:', body: 'Protege chats con contraseña, huella o rostro. Puedes bloquear chats sueltos o toda la app.' },
      { title: 'Sin anuncios:', body: 'Experiencia de mensajería sin publicidad.' },
    ],
    installSteps: [
      { title: 'Copia de seguridad de chats:', body: 'Abre WhatsApp, Ajustes > Chats > Copia de seguridad y guarda en Google Drive o almacenamiento local.' },
      { title: 'Permitir fuentes desconocidas:', body: 'Ajustes > Seguridad > Instalar apps desconocidas (o Apps > Acceso especial) y actívalo para tu gestor de archivos.' },
      { title: 'Descargar el APK:', body: 'Pulsa el botón de descarga y guarda el APK de GBWhatsApp en el dispositivo.' },
      { title: 'Instalar el APK:', body: 'Abre el archivo y pulsa Instalar. Espera a que termine.' },
      { title: 'Verificar tu número:', body: 'Abre GBWhatsApp, verifica el número y restaura la copia durante la configuración si quieres.' },
      { title: 'Disfruta:', body: '¡Empieza a usar GBWhatsApp con todas sus funciones extra!' },
    ],
    cmpRows: [
      { feat: 'Ocultar estado en línea', gb: 'yes', wo: 'no' },
      { feat: 'Ocultar ticks azules', gb: 'yes', wo: 'limited' },
      { feat: 'Temas personalizados', gb: 'thousands', wo: 'limited' },
      { feat: 'Límite tamaño vídeo', gb: '90MB', wo: '16MB' },
      { feat: 'Programar mensajes', gb: 'yes', wo: 'no' },
      { feat: 'Bloqueo de app', gb: 'builtIn', wo: 'no' },
      { feat: 'Descargar estados', gb: 'yes', wo: 'no' },
      { feat: 'Varias cuentas', gb: 'yes', wo: 'no' },
    ],
    privacyItems: [
      { title: 'Ocultar estado en línea:', body: 'Parece que estás desconectado aunque uses la app.' },
      { title: 'Ocultar ticks azules:', body: 'Lee sin que el remitente vea el doble check azul.' },
      { title: 'Ocultar segundo tick:', body: 'Muestra entregado sin mostrar cuando se ha leído.' },
      { title: 'Ocultar «escribiendo…»:', body: 'Escribe sin que salga el indicador.' },
      { title: 'Ocultar grabación:', body: 'Graba audios sin mostrar estado de grabación.' },
      { title: 'Modo fantasma:', body: 'Usa la app de forma muy discreta con el modo fantasma.' },
      { title: 'Ver mensajes borrados:', body: 'Lee mensajes que otros borraron gracias a anti-borrado.' },
      { title: 'Privacidad por contacto:', body: 'Ajustes distintos de privacidad para cada contacto.' },
    ],
    antiBanItems: [
      { title: 'Actualizaciones frecuentes:', body: 'El equipo publica mejoras para compatibilidad y seguridad.' },
      { title: 'Servidores oficiales:', body: 'GBWhatsApp usa los servidores de WhatsApp, lo que reduce señales raras.' },
      { title: 'Enfoque en privacidad:', body: 'Diseño orientado a la privacidad y menos comportamientos llamativos.' },
      { title: 'Pruebas beta:', body: 'Las novedades se prueban antes del lanzamiento público.' },
    ],
    faqItems: [
      { q: '¿Es seguro usar GBWhatsApp?', a: 'En general sí, con precaución: hay protección anti-baneo pero siempre existe un pequeño riesgo en apps modificadas. Descarga solo de sitios fiables y haz copias de seguridad.' },
      { q: '¿Puedo usar GBWhatsApp y el WhatsApp oficial a la vez?', a: 'Sí, en el mismo dispositivo con números distintos. También puedes usar la función de app en paralelo para varias cuentas.' },
      { q: '¿Se pasa mi historial a GBWhatsApp?', a: 'Sí, puedes restaurar la copia al configurar GBWhatsApp. Antes crea una copia en WhatsApp oficial.' },
      { q: '¿Tiene modo oscuro?', a: 'Sí, hay varios temas oscuros y opción integrada de modo oscuro, además de temas oscuros propios.' },
      { q: '¿Con qué frecuencia se actualiza?', a: 'Con regularidad, suele ser cada pocas semanas, con nuevas funciones y correcciones para Android nuevo.' },
      { q: '¿Puedo pasar GBWhatsApp a otro teléfono?', a: 'Sí, haz una copia completa en ajustes, copia los archivos al nuevo móvil y restáurala al instalar.' },
      { q: '¿Qué hago si no se instala?', a: 'Comprueba «Instalar aplicaciones desconocidas», vacía caché del navegador, vuelve a descargar el APK y libera espacio.' },
      { q: '¿Me pueden banear por usar GBWhatsApp?', a: 'Hay protección anti-baneo, pero ningún mod es riesgo cero. Evita automatización agresiva y úsalo con normalidad.' },
    ],
    altCards: [
      { href: '/fmwhatsapp/', name: 'FMWhatsApp', desc: 'Mod popular con colección de temas y extras.' },
      { href: '/yowhatsapp/', name: 'YoWhatsApp', desc: 'Gran biblioteca de temas y personalización detallada.' },
      { href: '/ogwhatsapp/', name: 'OGWhatsApp', desc: 'Versión modificada con funciones y privacidad propias.' },
      { href: '/jtwhatsapp/', name: 'JTWhatsApp', desc: 'Mod completo con actualizaciones frecuentes.' },
      { href: '/mbwhatsapp/', name: 'MBWhatsApp', desc: 'Mod moderno con diseño fluido.' },
      { href: '/whatsapp-plus/', name: 'WhatsApp Plus', desc: 'De los mods clásicos, con buena estabilidad.' },
      { href: '/gold-whatsapp/', name: 'Gold WhatsApp', desc: 'Mod premium con tema dorado y personalización exclusiva.' },
      { href: '/red-whatsapp/', name: 'Red WhatsApp', desc: 'Mod vibrante con tema rojo llamativo y funciones mejoradas.' },
      { href: '/blue-whatsapp/', name: 'Blue WhatsApp', desc: 'Mod elegante con tema azul y opciones de personalización.' },
    ],
    safetyItems: [
      { title: 'Fuente fiable:', body: 'Descarga solo desde webs reconocidas para evitar APK falsos o malware.' },
      { title: 'Revisa permisos:', body: 'Mira los permisos solicitados; la app necesita varios para funcionar bien.' },
      { title: 'Copias de seguridad:', body: 'Haz copias de chats para no perder datos.' },
      { title: 'Actualiza la app:', body: 'Las actualizaciones traen parches de seguridad.' },
      { title: 'Anti-baneo:', body: 'Activa la protección anti-baneo en los ajustes si está disponible.' },
    ],
    updateItems: [
      { title: 'Mejor anti-baneo:', body: 'Medidas para reducir suspensiones de cuenta.' },
      { title: 'Más temas:', body: 'Más de 50 temas nuevos en la tienda.' },
      { title: 'Correcciones:', body: 'Varios errores de versiones anteriores solucionados.' },
      { title: 'Rendimiento:', body: 'App más fluida y optimizada.' },
      { title: 'Privacidad:', body: 'Nuevas opciones de privacidad y mejoras del modo fantasma.' },
      { title: 'Calidad de medios:', body: 'Mejor calidad al comprimir foto y vídeo para compartir.' },
      { title: 'Fuentes nuevas:', body: 'Más de 20 fuentes nuevas.' },
      { title: 'Android 15:', body: 'Compatibilidad con Android 15.' },
    ],
    troubleSections: [
      { h3: 'No se instala GBWhatsApp', lead: 'Prueba lo siguiente:', tips: ['Activa «Instalar aplicaciones desconocidas»', 'Vacia caché del navegador y vuelve a descargar', 'Libera espacio de almacenamiento', 'Desactiva optimización de batería para GBWhatsApp'] },
      { h3: 'GBWhatsApp se cierra', lead: 'Si crashea constantemente:', tips: ['Limpia caché desde ajustes', 'Actualiza a la última versión', 'Reinstala la app', 'Busca apps en conflicto'] },
      { h3: 'No verifica el número', lead: 'Si falla la verificación:', tips: ['Comprueba la conexión', 'Confirma el número', 'Prueba SMS en lugar de llamada', 'Borra datos de la app e inténtalo otra vez'] },
      { h3: 'Problemas con la copia de seguridad', lead: 'Si la copia falla:', tips: ['Configura bien Google Drive', 'Mira el espacio en Drive', 'Usa copia local', 'Usa misma familia de versión al restaurar'] },
    ],
  };
